import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const TEMPORARY_PERMISSION_UPDATE_RESOURCE = "temporary-permission" as const;
export const TEMPORARY_PERMISSION_UPDATE_API_PATH = `/v1/${TEMPORARY_PERMISSION_UPDATE_RESOURCE}/{uuid}` as const;

export type TemporaryPermissionUpdateBody =
  paths[typeof TEMPORARY_PERMISSION_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type TemporaryPermissionUpdateResponse =
  paths[typeof TEMPORARY_PERMISSION_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useTemporaryPermissionUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TemporaryPermissionUpdateResponse, Error, TemporaryPermissionUpdateBody & { uuid: string }>({
    mutationFn: async (temporaryPermission: TemporaryPermissionUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = temporaryPermission;
      const response = await alphartisApiAxios.patch<TemporaryPermissionUpdateResponse>(
        `/v1/${TEMPORARY_PERMISSION_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [TEMPORARY_PERMISSION_UPDATE_RESOURCE],
      });
    },
  });
};
